import { FC, useCallback } from 'react';

import { matchPath, useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';

import logo from 'assets/images/headerLogo.svg';

import { getDefaultUserRoute } from 'app/providers/utils';
import { useAuth } from 'hooks';
import { CommonButton } from 'components';
import { useAppDispatch } from 'state/hooks';
import { setSignupModal } from 'state/slices/account';
import { CookieBanner } from 'components/CookieBanner';
import { UnitsType } from 'app/api/quotes';
import { ROUTES } from 'app/routes/constants';
import { useQuery } from 'react-query';
import { getProductData } from 'app/api/products';

import { UserMenu } from '../UserMenu';
import { HeaderSearch } from '../HeaderSearch';
import { NavigationContainer } from '../NavigationContainer';
import { Notifications } from '../Notifications';
import { styles } from './styles';

interface HeaderProps {
  isShadow: boolean;
  isActionsEnabled?: boolean;
}

export const Header: FC<HeaderProps> = ({ isShadow, isActionsEnabled = true }) => {
  const navigate = useNavigate();
  const { isBuyer, activeUser } = useAuth();

  const handleRedirectHome = useCallback(() => {
    navigate(getDefaultUserRoute(isBuyer));
  }, [isBuyer, navigate]);

  const dispatch = useAppDispatch();
  const isProductDetailsPage = matchPath(ROUTES.common.product, window.location.pathname);
  const { id } = useParams<{ id: string }>();
  const { data: productData } = useQuery(['company', id], () => getProductData(parseInt(id as string, 10)), {
    enabled: !!isProductDetailsPage,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const onClickRequestAccess = () => {
    const metadata =
      isProductDetailsPage && productData
        ? {
            quantity: 0,
            units: UnitsType.KG,
            product: productData,
          }
        : {};
    dispatch(setSignupModal({ isOpen: true, state: 'requestAccess', source: 'header', metadata }));
  };
  const onClickLogin = () => dispatch(setSignupModal({ isOpen: true, state: 'login' }));

  return (
    <Box sx={{ ...styles.mainWrap(isShadow) }}>
      <CookieBanner />

      <Box sx={{ ...styles.wrap }}>
        <Box sx={{ ...styles.leftSideWrap }}>
          <Box sx={{ ...styles.logo }}>
            <Box component="img" src={logo} onClick={handleRedirectHome} />
          </Box>

          {isActionsEnabled && (
            <>
              <Box sx={{ ...styles.spacer }} />
              <NavigationContainer />{' '}
            </>
          )}
        </Box>

        {isActionsEnabled && (
          <Box sx={{ ...styles.rightSideWrap }}>
            {(isBuyer || !activeUser) && <HeaderSearch />}
            {activeUser ? (
              <>
                <Notifications />
                <UserMenu />
              </>
            ) : (
              <>
                <CommonButton onClick={onClickRequestAccess}>Request Free Access</CommonButton>
                <CommonButton onClick={onClickLogin} color="inherit" sx={styles.login}>
                  Login
                </CommonButton>
              </>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
